import './style.scss';

import React from 'react';
import { CartButton } from 'components/cart';
import Login from './login';
import Search from 'components/search';
import Address from './address';
import HeaderNav from './nav';
import Banner from '../banner';
import AvailabilityModal from '../availability';
import SauceyLogo from 'images/saucey.svg';

class HeaderComponent extends React.Component {
  render() {
    const { pageName, cartOpen, headerRef } = this.props;
    const className = 'nav-container';

    return (
      <div className={className}>
        <div
          className={'app-header' + (cartOpen ? ' app-header--cart-open' : '')}
          ref={headerRef}
        >
          <div id="header">
            <i className="icon-hamburger js-slideout-toggle" />
            <a href="/" className="nav-logo">
              <img src={SauceyLogo} />
            </a>
            <HeaderNav />
            <a className="become-a-courier" href="/apply">
              Become a Courier
            </a>
            <Login />
          </div>
          <nav id="nav-bar">
            <Search />
            <div id="nav-right">
              <Address trackingParams={{ page: pageName, source: 'Header' }} />
              <div className="nav-bar__cart-btn-container">
                <CartButton />
              </div>
            </div>
          </nav>
          <Banner />
          <AvailabilityModal />
        </div>
      </div>
    );
  }
}

export default HeaderComponent;



// WEBPACK FOOTER //
// ./shared/components/header/index.js